//
import { ModuleLayout } from '@/components/reusable_components/next'

//
import PurchaseDebitNoteCreateView from '@/views/Purchase/PchPurchaseDebitNote/PchPurchaseDebitNoteCreate'
import PurchaseDebitNoteListView from '@/views/Purchase/PchPurchaseDebitNote/PchPurchaseDebitNoteList'
import PurchaseDebitNoteUpdateView from '@/views/Purchase/PchPurchaseDebitNote/PchPurchaseDebitNoteUpdate'

//
export default {
    path: 'purchase_debit_note',
    component: ModuleLayout,
    children: [
        {
            path: '',
            name: 'purchase-debit-note-list',
            component: PurchaseDebitNoteListView,
        },
        {
            path: 'create',
            name: 'purchase-debit-note-create',
            component: PurchaseDebitNoteCreateView,
            meta: {
                title: 'Crear nota de debito',
            },
        },
        {
            path: ':id',
            name: 'purchase-debit-note-update',
            component: PurchaseDebitNoteUpdateView,
            meta: {
                title: 'Detalle de nota de debito',
            },
        },
    ],
    meta: {
        title: 'Notas de debito',
    },
}
